import Axios from 'axios';

const client = Axios.create({
    // baseURL: "http://127.0.0.1:8080/api/",
    // baseURL: "http://carclick.ir/api/",
    baseURL: "https://prv.carclick.ir/api/",
    responseType: "json"
});

export default client;